import React, { useState } from "react";
import { ImLocation } from "react-icons/im";
import { ImMail3 } from "react-icons/im";
import { IoCall } from "react-icons/io5";
import { HiClock } from "react-icons/hi2";
import emailjs from "emailjs-com";
import { Form, Input, TextArea, Button, FormInput } from "semantic-ui-react";
import Swal from "sweetalert2";

const SERVICE_ID = "dhproject1";
const TEMPLATE_ID = "template_inafc7l";
const PUBLIC_KEY = "GWhQ-YBtzZlmbESbK";

const ContactUs = ( {language} ) => {
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const [errors, setErrors] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (!e.target.checkValidity()) {
      const newErrors = {};
      const formElements = e.target.elements;

      for (let i = 0; i < formElements.length; i++) {
        const element = formElements[i];
        if (!element.checkValidity()) {
          newErrors[element.name] = element.validationMessage;
        }
      }

      setErrors(newErrors);
      return;
    }

    emailjs
      .sendForm(SERVICE_ID, TEMPLATE_ID, e.target, PUBLIC_KEY, {
        name: e.target.name.value,
        email: e.target.email.value,
        message: e.target.message.value,
        phone: e.target.phone.value,
      })
      .then(
        (result) => {
          console.log(result.text);
          Swal.fire({
            icon: "success",
            title: "Message Sent Successfully",
          });
        },
        (error) => {
          console.log(error.text);
          Swal.fire({
            icon: "error",
            title: "Oops, something went wrong",
            text: error.text,
          });
        }
      );
    e.target.reset();
  };

  const handleInputChange = (e) => {
    const { name, value, validity } = e.target;
    const newErrors = { ...errors, [name]: "" };

    if (!validity.valid) {
      newErrors[name] = e.target.validationMessage;
    }

    if (name === "mobile_no") {
      const numericValue = value.replace(/\D/g, "").slice(0, 10);
      e.target.value = numericValue;
      newErrors[name] = validity.valid ? "" : e.target.validationMessage;
    }

    setErrors(newErrors);

    const form = e.target.form;
    setIsSubmitDisabled(!form.checkValidity());
  };

  return (
    <>
      <div className="border border-gray-100 shadow-sm relative my-2 items-center h-[80%] flex flex-col pb-16 bg-[#ebf7ff]">
        {language === 'en' && (
        <h1 className="font-bold text-4xl text-center py-16">Contact Us</h1>
        )}
        {language === 'hi' && (
        <h1 className="font-bold text-4xl text-center py-16">संपर्क करें</h1>
        )}
        <div className="flex flex-col sm:flex-row gap-6 justify-between items-center w-full max-w-5xl mx-auto">
          <div className="px-6 space-y-4">
            <div className="flex flex-row space-x-4">
              <div className="rounded-full h-max p-3 bg-orange-400 relative">
                {<ImLocation className="absolute bottom-2 right-1 text-xl" />}
              </div>
              <div>
                {language === 'en' && (
                <h1 className="font-bold text-md">Our Office Address</h1>
                )}
                {language === 'hi' && (
                <h1 className="font-bold text-md">हमारा कार्यालय पता</h1>
                )}
                {language === 'en' && (
                <p>Plot No 79,Behind Sodala Thana,Shiv Path</p>
                )}
                {language === 'hi' && (
                <p>प्लॉट नंबर 79, सोडाला थाने के पीछे, शिव पथ</p>
                )}
                {language === 'en' && (
                <p>,Ram Nagar,Sodala,Jaipur,Rajasthan 302019</p>
                )}
                {language === 'hi' && (
                <p>, राम नगर, सोडाला, जयपुर, राजस्थान 302019</p>
                )}
              </div>
            </div>
            <div className="flex flex-row space-x-4 ">
              <div className="flex flex-row space-x-2 rounded-full h-max p-3 bg-orange-400 relative">
                {<ImMail3 className="absolute bottom-2 right-1 text-xl" />}
              </div>
              <div>
                {language === 'en' && (
                <h1 className="font-bold text-md">General Enquiries</h1>
                )}
                {language === 'hi' && (
                <h1 className="font-bold text-md">सामान्य पूछताछ</h1>
                )}
                <p>archimaya83@gmail.com</p>
              </div>
            </div>
            <div className="flex flex-row space-x-4 ">
              <div className="rounded-full h-max p-3 bg-orange-400 relative">
                {<IoCall className="absolute bottom-2 right-1 text-xl" />}
              </div>
              <div>
                {language === 'en' && (
                <h1 className="font-bold text-md">Call Us</h1>
                )}
                {language === 'hi' && (
                <h1 className="font-bold text-md">हमें कॉल करें</h1>
                )}
                <p>+91-8890079787</p>
              </div>
            </div>
            <div className="flex flex-row space-x-4 ">
              <div className="rounded-full h-max p-3 bg-orange-400 relative">
                {<HiClock className="absolute bottom-2 right-1 text-xl" />}
              </div>
              <div>
                {language === 'en' && (
                <h1 className="font-bold text-md">Our Timing</h1>
                )}
                {language === 'hi' && (
                <h1 className="font-bold text-md">हमारा समय</h1>
                )}
                {language === 'en' && (
                <p>Mon - Sat : 10:00 AM - 07:00 PM</p>
                )}
                {language === 'hi' && (
                <p>सोम - शनि: सुबह 10:00 बजे से शाम 07:00 बजे तक
                </p>
                )}
                {language === 'en' && (
                <p>Sun : Closed </p>
                )}
                {language === 'hi' && (
                <p>रविवार: बंद </p>
                )}
              </div>
            </div>
          </div>
          <form
            className="text-center flex flex-col justify-center items-center space-y-4 p-2 w-full px-6 sm:pr-2 sm:pl-0 sm:w-96  "
            onSubmit={handleOnSubmit}
          >
            <input
              className={`p-2 border-gray-400 border rounded-md w-full ${
                errors.name ? "border-red-500" : ""
              }`}
              type="text"
              name="from_name"
              id="name"
              placeholder="YOUR NAME"
              required={true}
              onChange={handleInputChange}
            />
            {errors.name && <p className="text-red-500">{errors.name}</p>}
            <input
              className={`p-2 border-gray-400 border rounded-md w-full ${
                errors.email ? "border-red-500" : ""
              }`}
              type="email"
              id="email"
              name="reply_to"
              required={true}
              placeholder="YOUR EMAIL"
              pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}"
              onChange={handleInputChange}
            />
            {errors.email && <p className="text-red-500">{errors.email}</p>}
            <input
              className={`p-2 border-gray-400 border rounded-md w-full ${
                errors.phone ? "border-red-500" : ""
              }`}
              type="text"
              id="phone"
              name="mobile_no"
              placeholder="YOUR CONTACT NUMBER"
              pattern="([/^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/i]"
              minLength={10}
              maxLength={10}
              required={true}
              onChange={handleInputChange}
            />
            {errors.phone && <p className="text-red-500">{errors.phone}</p>}
            <textarea
              className={`p-2 border-gray-400 border rounded-md w-full resize-none ${
                errors.message ? "border-red-500" : ""
              }`}
              type="text"
              name="message"
              id="message"
              placeholder="YOUR MESSAGE"
              required={true}
              rows={4}
              onChange={handleInputChange}
            />
            {errors.message && <p className="text-red-500">{errors.message}</p>}
            <div className="flex justify-center w-fit">
              {language === 'en' && (
              <button
                className={`rounded-3xl bg-orange-500 text-white px-6 py-2 ${
                  isSubmitDisabled
                    ? "pointer-events-none opacity-50"
                    : "hover:bg-orange-400 hover:scale-110 ease-in duration-100"
                }`}
                type="Submit"
                disabled={isSubmitDisabled}
              >
                submit
              </button>
              )}
              {language === 'hi' && (
              <button
                className={`rounded-3xl bg-orange-500 text-white px-6 py-2 ${
                  isSubmitDisabled
                    ? "pointer-events-none opacity-50"
                    : "hover:bg-orange-400 hover:scale-110 ease-in duration-100"
                }`}
                type="submit"
                disabled={isSubmitDisabled}
              >
                सबमिट करें
              </button>
              )}
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default ContactUs;
